import Navbar from "../navbar/Navbar";
import { useSelector } from "react-redux";
import SideMenu from "../../components/eventLayout/SideMenu";
import DemoEventBar from "../../components/eventLayout/DemoEventBar";
import { Outlet } from "react-router-dom";

const EventHomeLayout = () => {
  const singleEvent = useSelector((state) => state.eventData);

  return (
    <>
      <div className="flex flex-col">
        {singleEvent?.isMockEvent && (
          <div className="header h-10 w-full">
            <DemoEventBar />
          </div>
        )}
        <div className="header h-[58px] w-full">
          <Navbar />
        </div>
        <div className="w-full flex justify-center items-center flex-col ">
          <div className="w-full overflow-x-hidden">
            <div
              className={`grid grid-cols-[228px_1fr] ${
                singleEvent?.isMockEvent
                  ? "h-[calc(100vh_-_98px)]"
                  : " h-[calc(100vh_-_58px)]"
              }  `}
            >
              <div className="sidebar md:w-[228px]">
                <SideMenu
                  eventTitle={singleEvent?.title}
                  organizer={singleEvent?.primaryOrganizer?.organization}
                  singleEvent={singleEvent}
                />
              </div>
              <div
                className={`container ml-[30px] w-full ${
                  singleEvent.isMockEvent
                    ? "h-[calc(100vh_-_98px)]"
                    : " h-[calc(100vh_-_58px)]"
                }`}
              >
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventHomeLayout;
